import { UdlEvent, LinkPlacementName } from '../../hooks/useUdl';

type UDLEventsType = Record<string, UdlEvent>;

const EVENTS: UDLEventsType = {
  pdpConfigView: {
    event: 'e_pageView',
    pageNameL5: 'pdp-config',
    pageNameL8: '',
  },
  checkoutButtonClicked: {
    event: 'e_addToCart',
  },
  checkoutButtonDisplayed: {
    event: 'e_pageView',
    pageNameL5: 'pdp-config',
    pageNameL8: '',
  },
  viewPageSummary: {
    event: 'e_pageView',
    pageNameL5: 'summary',
    pageNameL8: 'summary',
  },
  newAddressPV: {
    event: 'e_pageView',
    pageNameL5: 'checkout',
    pageNameL8: 'checkout',
  },
  billingAddressPV: {
    event: 'e_pageView',
    pageNameL5: 'checkout',
    pageNameL8: 'billing-address-enabled',
  },
  selectPaymentMethodPV: {
    event: 'e_pageView',
    pageNameL5: 'checkout',
    pageNameL8: 'checkout',
  },
  selectedPaymentPV: {
    event: 'e_pageView',
    pageNameL5: 'checkout',
    pageNameL8: 'checkout',
  },
  orderConfirmationPageView: {
    event: 'e_pageView',
    pageNameL5: 'checkout',
    pageNameL8: 'purchase',
  },
} as UDLEventsType;

const udlEvents = {
  getEventByID: (id: string): UdlEvent => EVENTS[id],
  getEventByLinkId: (linkID: string): UdlEvent => {
    const event = Object.values(EVENTS).find(
      (event) => event.linkID === linkID
    );
    return event;
  },
  getFederatedEvent: (
    id: string,
    linkPlacement: LinkPlacementName,
    linkID: string
  ): UdlEvent => ({
    ...EVENTS[id],
    linkPlacement,
    linkID,
  }),
  getEventWithObject: (id: string, object: object): UdlEvent => ({
    ...EVENTS[id],
    ...object,
  }),
};

export default udlEvents;
